import InvoiceablesListPanel from './invoiceables-detail-table-panel.vue';
import DeleteInvoiceableModal from './delete-invoiceable-modal.vue';
import EditInvoiceableModal from './edit-invoiceable-modal.vue';
export default{
  'invoiceables-list-panel': InvoiceablesListPanel,
  DeleteInvoiceableModal,
  EditInvoiceableModal
}